import { Inject, Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { StreamData, STREAM_DATA, MAIN_STREAM_DATA } from './stream.token';

@Injectable({
  providedIn: 'root',
})
export class StreamService {
  public http = inject(HttpClient);

  public isMainStreamSelected = signal(true);
  public isTwitchStreamSelected = signal(false);

  private streams = signal<StreamData[]>([]);

  constructor(
    @Inject(STREAM_DATA) private streamData: StreamData[],
    @Inject(MAIN_STREAM_DATA) private mainStreamData: StreamData,
  ) {}

  public getStreams() {
    return this.streams();
  }

  public getRaceStreamData() {
    return this.streamData;
  }

  public getMainStreamData() {
    return this.mainStreamData;
  }

  public getTwitchStreamData() {
    const streamData: StreamData = {
      id: 'twitch-stream',
      isLive: true,
    };
    return streamData;
  }

  public getStreamDataByCarNumber(carNumber: string): StreamData {
    return this.streamData.find((sd) => sd.carNumber === carNumber);
  }
}
